import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AudioProvider } from "@/context/AudioContext";
import { IntroGate } from "@/components/site/IntroGate";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";
import { useAudio } from "@/context/AudioContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Markets from "@/pages/Markets";
import MarketDetail from "@/pages/MarketDetail";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Tools from "@/pages/Tools";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

const AppInner = () => {
  const { armAutoplay } = useAudio();
  const [entered, setEntered] = useState(() => {
    try { return sessionStorage.getItem("bp_entered") === "1"; } catch (e) { return false; }
  });

  useEffect(() => {
    document.body.style.overflow = entered ? "" : "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [entered]);

  // Once the visitor is inside, the brand jingle auto-plays on the first
  // interaction (scroll / touch / click), unless they explicitly muted it.
  useEffect(() => {
    if (entered) armAutoplay();
  }, [entered, armAutoplay]);

  const handleEnter = () => {
    try { sessionStorage.setItem("bp_entered", "1"); } catch (e) {}
    setEntered(true);
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      {!entered && <IntroGate onEnter={handleEnter} />}
      <Navbar />
      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/markets/:slug" element={<MarketDetail />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/data-retention" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" theme="dark" richColors closeButton />
    </BrowserRouter>
  );
};

function App() {
  return (
    <AudioProvider>
      <div className="App">
        <AppInner />
      </div>
    </AudioProvider>
  );
}

export default App;
